import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

export default function ProtectedRoute({ children, allowClient = false, onlyClient = false }) {
    const { isAuthenticated, initializing, user } = useAuth();
    const location = useLocation();

    if (initializing) {
        return (
            <div className="flex h-screen w-full items-center justify-center bg-background">
                <div className="flex flex-col items-center gap-3 text-muted-foreground">
                    <Loader2 className="h-6 w-6 animate-spin text-[hsl(var(--brand))]" />
                    <span className="text-sm">Yükleniyor…</span>
                </div>
            </div>
        );
    }

    if (!isAuthenticated) {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    const isClient = user?.role === "client";

    // Portal route: only client users may access
    if (onlyClient && !isClient) {
        return <Navigate to="/dashboard" replace />;
    }

    // Internal routes: block client users unless allowClient is set
    if (!allowClient && isClient) {
        return <Navigate to="/portal" replace />;
    }

    return children;
}
